module.exports = __webpack_public_path__ + "static/media/8-6.85de6adf.mp3";